module.exports = __webpack_public_path__ + "img/sintesis.d6f3a363.svg";